<div class="add-button">
  <div class="add-button__container add-button__container--{{ iconPosition }}">
    <img
      class="add-button__icon add-button__icon--{{ iconSize }}"
      alt="Add button icon"
      mfpLazyImage
      [lazySrc]="icon"
      [ngClass]="{ 'add-button__icon--no-margin': !label }"
    />
    <ng-container *ngIf="label">
      <span class="add-button__label add-button__label--{{ color }} add-button__label--{{ labelSize }}">{{ label }}</span>
    </ng-container>
  </div>
</div>
